/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.membership.cards.list.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.view.application.dataGrid.controllers',
  'acme.view.application.layouts.membership.cards.deleteModal.controllers'
])

.controller('LayoutsMembershipCardsListController', ['$scope', '$filter', '$state', '$timeout', '$uibModal', '$q', 'ApiService', 'HelpersService', 'CalendarService', 'GridStateFactory', 'GridDefinitionFactory', 'UserPreferencesService', function($scope, $filter, $state, $timeout, $uibModal, $q, ApiService, HelpersService, CalendarService, GridStateFactory, GridDefinitionFactory, UserPreferencesService) {

    $scope.layoutsMembershipCardsList = {

      model: {
        list: [],
        pagination: {
          page: 1,
          pageSize: 100,
          sortDirection: 'asc',
          sortField: '',
          count: 0
        }
      },
      filtered: [],
      searchQuery: '',
      activeLayout: null,

      // Grid
      viewId: '',
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      cardLayoutGridName: $state.current.name+'.grid0',
      dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),

      // Randoms
      isLoaded: false,
      deleteModal: {},

      optionsOverride: {
        rowHeight: 35,
        data: 'layoutsMembershipCardsList.model.list',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize) {
            $scope.layoutsMembershipCardsList.onDataGridPaginate(newPageNumber, newPageSize);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.layoutsMembershipCardsList.onDataGridSortChange(grid, columns);
          },
          onDblClick: function(item) {
            $scope.layoutsMembershipCardsList.onDblClick(item);
          },
          activate: function(item) {
            $scope.layoutsMembershipCardsList.activateLayout(item);
          },
          deactivate: function(item) {
            $scope.layoutsMembershipCardsList.deactivateLayout(item);
          },
          remove: function (item) {
            $scope.layoutsMembershipCardsList.gridRemove(item);
          },
          dateFormat: function() {
            return $scope.layoutsMembershipCardsList.dateFormat;
          }
        },
        columnDefs: [
          {
            field: 'active',
            displayName: 'Active',
            onCellNavClick: function(row, col) {
              if (!row.entity.active) {
                $scope.layoutsMembershipCardsList.optionsOverride.appScopeProvider.activate(row.entity.id);
              } else {
                $scope.layoutsMembershipCardsList.optionsOverride.appScopeProvider.deactivate(row.entity.id);
              }
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents layouts-membership-cards-list-check" ng-class="col.colIndex()" data-ng-show="!row.entity.active"><a data-no-tabbing data-ng-click="grid.appScope.activate(row.entity.id)"><span class="fa fa-square-o" aria-hidden="true"></span><span class="sr-only"> - activate this layout</span></a></div>' +
                          '<div class="clickable ui-grid-cell-contents layouts-membership-cards-list-check" ng-class="col.colIndex()" data-ng-show="row.entity.active"><a data-no-tabbing data-ng-click="grid.appScope.deactivate(row.entity.id)"><span class="fa fa-check-square-o" aria-hidden="true"></span><span class="sr-only"> - deactivate this layout</span></a></div>',
            width: 35,
            visible: true
          },
          {
            field: 'name',
            displayName: 'Name',
            visible: true
          },
          {
            field: 'status.currentStatus',
            displayName: 'Status',
            visible: true
          },
          {
            field: 'status.draftDate',
            displayName: 'Last Update',
            cellFilter: 'date: grid.appScope.dateFormat()',
            cellFormatter: function(item) {
              return $filter('date')(item.value, $scope.layoutsMembershipCardsList.dateFormat);
            },
            visible: true
          },
          {
            field: 'edit',
            displayName: 'Edit',
            onCellNavClick: function(row, col) {
              $state.go('application.layouts.membership.cards.edit', { id: row.entity.id });
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-no-tabbing data-ui-sref="application.layouts.membership.cards.edit({ id: row.entity.id })" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false,
            width: 60
          },
          {
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.layoutsMembershipCardsList.optionsOverride.appScopeProvider.remove(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-no-tabbing data-ng-click="grid.appScope.remove(row.entity)" role="button">Remove<span class="sr-only"> - Opens Dialog</span></a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false,
            width: 80
          }
        ]
      },


      init: function() {

        $scope.$emit('Application::contentTitleChange', {
          title: 'Membership Card Layouts',
          buttonRight: {
            label: '+ Create Card Layout',
            action: function() {
              $state.go('application.layouts.membership.cards.create');
            }
          }
        });

        this.getActive();

        this.viewId = $state.current.name;
        this.gridDefinition.init(this.cardLayoutGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);
        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
      },

      initData: function() {
        var self = $scope.layoutsMembershipCardsList,
            props = self.gridDefinition.getGridState();

        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getSummaries();
      },

      getSummaries: function() {
        var self = $scope.layoutsMembershipCardsList;
        self.gridState.setPropertyValue('search', self.searchQuery);
        ApiService.membership.cards.layouts.list(self.gridState.getGridState()).then(this.success.getSummaries, this.error.getSummaries);
      },

      getActive: function() {
        var self = $scope.layoutsMembershipCardsList;
        ApiService.membership.cards.layouts.list({active: true}).then(this.success.getActive, this.error.getActive);
      },

      findLayout: function(id) {
        var i, ii,
          r = false;

        for (i=0,ii=this.model.list.length;i<ii;i++) {
          if (this.model.list[i].id === id) {
            r = {
              index: i,
              instance: this.model.list[i]
            };
          }
        }
        return r;
      },

      success: {

        init: function(response) {},

        getSummaries: function (response, status, headers, config) {
          var self = $scope.layoutsMembershipCardsList;

          self.isLoaded = true;
          self.model = response.data.payload;
          self.gridDefinition.isLoaded = true;

          if (!$scope.$$phase) {
            $scope.$apply();
          }

          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.list.length, totalItems: self.model.pagination.count});
          }, 10);
        },

        getActive: function(response) {
          var self = $scope.layoutsMembershipCardsList;
          if (response.data.payload.list.length) {
            self.activeLayout = response.data.payload.list[0];
          }
        },

        saveMembershipCard: function(response) {
          var self = $scope.layoutsMembershipCardsList;
          self.getSummaries();
          self.getActive();
        },

        gridRemove: function(response) {
          var self = $scope.layoutsMembershipCardsList;
          self.getSummaries();
        }

      },

      error: {
        init: function(response) {},
        getSummaries: function (response, status, headers, config) {},
        getActive: function(){},
        saveMembershipCard: function(response) {},
        gridRemove: function (response) {}
      },


      // Events
      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.layoutsMembershipCardsList;
        self.gridState.updateGridState(newPage, pageSize);
        self.getSummaries();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.layoutsMembershipCardsList, data = columns[0];
        if (data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getSummaries();
        }
      },

      onDblClick: function(item) {
        // Create and edit are handled by the same controller
        $state.go('application.layouts.membership.cards.edit', { id: item.entity.id });
      },

      activateLayout: function(id) {
        var self = $scope.layoutsMembershipCardsList,
            newActive = self.findLayout(id);

        console.warn(newActive);

        if (newActive) {
          self.model.list[newActive.index].active = true;

          if (self.activeLayout) {

            angular.forEach(self.model.list, function(item, key) {
              if (item.id === self.activeLayout.id) {
                item.active = false;
              }
            });

            self.activeLayout.active = false;
            $q.all(
              ApiService.membership.cards.layouts.update(self.model.list[newActive.index]),
              ApiService.membership.cards.layouts.update(self.activeLayout)
            ).then(self.success.saveMembershipCard, self.error.saveMembershipCard);
          } else {
            ApiService.membership.cards.layouts.update(self.model.list[newActive.index]).then(self.success.saveMembershipCard, self.error.saveMembershipCard);
          }
        }
      },

      deactivateLayout: function(id) {
        var self = $scope.layoutsMembershipCardsList,
            active = self.findLayout(id);
        if (active) {
          self.model.list[active.index].active = false;
          self.activeLayout = null;
          ApiService.membership.cards.layouts.update(self.model.list[active.index]).then(self.success.saveMembershipCard, self.error.saveMembershipCard);
        }
      },

      gridRemove: function(item) {
        var self = $scope.layoutsMembershipCardsList;

        self.deleteModal = $uibModal.open({
          templateUrl: 'views/application/views/layouts/membership/cards/modals/delete.tpl.html',
          size: 'md',
          controller: 'LayoutsMembershipCardsDeleteModalController',
          resolve: {
            currentLayout: function() {
              return item;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.deleteModal.result.then(function () {
          ApiService.membership.cards.layouts.remove(item.id).then(self.success.gridRemove, self.error.gridRemove);
        }, function () {
          // Do nothing
        });
      }

    };

    $scope.layoutsMembershipCardsList.init();

}]);
